import Axios from 'config/api';
import toast from 'react-hot-toast';
import { setCreateLoading} from 'redux/slices/installmentSlice';
import toastError from 'utils/toastError';

const url = '/payment/submit-pay-installment';
const navigateUrl = '/app/installments'

export const    create_installments = (data , navigate) => async (dispatch) => {
    dispatch(setCreateLoading(true))
    try {
        const { data : { data : { doc , message } } } = await Axios.post('/payment/submit-pay-installment' , data);
        toast.success(message);
        navigate(navigateUrl);
        return doc;
    } catch (err) {
        console.log('error' , err);
        toastError(err);
        throw err;
    } finally {
        dispatch(setCreateLoading(false));
    }
}

export const updateInstallmentDueDate = (id, data) => async (dispatch) => {
    try {
        const res = await Axios.put(`/sale/installment/${id}/due-date`, data);
        toast.success(res?.data?.message || "Installment due date updated successfully.");
        return res?.data?.data?.doc;
    } catch (err) {
        console.log('error', err);
        toastError(err);
        throw err;
    }
};
